import { SharedState } from "../../SharedProvider";

export const selectMapManualEditStatus = (state: SharedState) => state.rooms.maps?.mapManualEditStatus;
export const selectZonePlannerMapDrawColor = (state: SharedState) => state.rooms.maps?.zonePlannerMapDrawColor;

export const selectCroppedComponents = (state: SharedState) => state.rooms.maps?.croppedComponents;
export const selectMapCrop = (state: SharedState) => state.rooms.maps?.mapCrop;
export const selectMapPutStatus = (state: SharedState) => state.rooms.maps?.mapPutStatus;